import * as React from "react";
import * as moment from "moment";
import {Link} from "react-router-dom";
import {
    AnnualPolicyInfo,
    AnnualPolicyPremiumTypeEnum,
    ICacheManager,
    InstalmentsInfo,
    INTERACTION_PROCESS_CLAIM_IMPACT,
    INTERACTION_PROCESS_MTA_CHANGE_DIRECT_DEBIT,
    INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE,
    INTERACTION_PROCESS_MTA_REPLACE_CAR,
    INTERACTION_PROCESS_MTC,
    INTERACTION_PROCESS_MTC_LV,
    INTERACTION_PROCESS_NB,
    INTERACTION_PROCESS_PENDING_RENEWAL,
    INTERACTION_PROCESS_PENDING_RENEWAL_UPDATE_DD,
    INTERACTION_PROCESS_RENEWAL,
    NEW_PAYMENT,
    Party,
    PaymentCard,
    Policy,
    POLICY_STATUS_MTC,
    POLICY_STATUS_PENDING_RENEWAL,
    POLICY_STATUS_UNDERWRITING_FAILURE,
    PolicyHistory,
    PolicyPropertyEnum,
    PREMIUM_TYPE_ANNUAL,
    PREMIUM_TYPE_MONTHLY,
    ProductsEnum,
    Quote,
    Renewal,
    RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
    SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED,
    Types,
} from "@ferry/journey-services";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {UnpaidChangeBanner} from "../../../../../components/banners/UnpaidChangeBanner";
import * as Driver from "driver.js";
import {ChargebackBanner} from "../../../../../components/banners/ChargebackBanner";
import {CardExpiryBanner} from "../../../../../components/banners/CardExpiryBanner";
import {
    findMainAnnualPaymentCardByMainCardId,
    formatDateDMY,
    formatDateTime,
    getAmountWithDecimalDigits,
} from "../../../../../CommonFunctions";
import * as MobileDetect from "mobile-detect";
import {NextYearAutoRenewalBanner} from "../../../../../components/banners/NextYearAutoRenewalBanner";
import {PolicyWillBeRenewedBanner} from "../../../../../components/banners/PolicyWillBeRenewedBanner";
import {RenewalDeclinedBanner} from "../../../../../components/banners/RenewalDeclinedBanner";
import {AutoRenewalInviteBanner} from "../../../../../components/banners/AutoRenewalInviteBanner";
import {PolicyWillBeRenewedConfirmation} from "../../../../../components/modals/PolicyWillBeRenewedConfirmation";
import {AutoRenewalInviteAfterLogin} from "../../../../../components/modals/AutoRenewalInviteAfterLogin";
import {NoActivePolicyBanner} from "../../../../../components/banners/NoActivePolicyBanner";
import {GracePeriodModal} from "../../../../../components/banners/GracePeriodModal";
import {
    getBrandFromPolicyNumber,
    getPrettifiedInteractionBrandName,
    InfoBanner,
    MtaLimitWarningBanner,
    FalconNavigatorHeader,
    resourcesHelper,
    Footer,
} from "@ferry/portal-core";
import {ILookupService, Types as JourneyCoreTypeDefs} from "@athena-portal/plugin-journey";
import {ClaimImpactMtaSuccessModalWordingGenerator} from "./ClaimImpactMtaSuccessModalWordingGenerator";
import {SuccessfulPurchaseModal} from "../../../../../components/modals/SuccessfulPurchaseModal";
import {StorageSuccessModal} from "../../../../../components/modals/StorageSuccessModal";
import {RenewNextYearConfirmationModal} from "../../../../../components/modals/RenewNextYearConfirmationModal";
import {AutoRenewalQuestionModal} from "../../../../../components/modals/AutoRenewalQuestionModal";
import {AnnualTiles} from "./AnnualTiles";
import {FutureMTAExplainedHeader} from "../yourCarsPage/FutureMTAExplainedHeader";
import {AutomaticRenewalSuccessModal} from "../../../../../components/modals/AutomaticRenewalSuccessModal";
import {OverdueInstalmentBanner} from "../../../../../components/banners/OverdueInstalmentBanner";
import {LVDataLayerHelper} from "../../../../../utils/LVDataLayerHelper";
import {OutstandingPaymentBanner} from "../../../../../components/banners/OutstandingPaymentBanner";
import {NCDImpactedClaimBanner} from "../../../../../components/banners/NCDImpactedClaimBanner";
import {formatDate} from "@ferry/plugin-ferry-journey";
import {pushEventToAdobeDataLayerTimeout} from "../../../../../utils/AdobeDataLayerHelper";
import {maybePushPurchaseEvent} from "../../../common/purchaseEvent";
import {MigrationMissedPaymentBanner} from "../../../../../components/banners/MigrationMissedPaymentBanner";
import {GracePeriodBanner} from "../../../../../components/banners/GracePeriodBanner";
import {
    LvToAllianzUKTransferDashboardBanner
} from "../../../../../components/banners/LvToAllianzUKTransferDashboardBanner";
import {Types as CustomerPortalTypes} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";
import {SetUpDirectDebitBanner} from "../../../../../components/banners/SetUpDirectDebitBanner";
import {CancellationBanner} from "../../../../../components/banners/CancellationBanner";
import {RenewalMissedPaymentBanner} from "../../../../../components/banners/RenewalMissedPaymentBanner";
import {NextPaymentBanner} from "../../../../../components/banners/NextPaymentBanner";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IState {
    policy?: Policy;
    party?: Party;
    partyLoaded: boolean;
    quotes?: Quote[];
    quotesLoaded: boolean;
    claimSubmissionDate?: string;
    oldMissedPaymentProcess?: boolean;
    instalmentsInfo?: InstalmentsInfo;
    instalmentInfoLoaded: boolean;
    showCardExpiryBanner: boolean;
    showFeedbackDialog: boolean;
    displayOverlay: boolean;
    renewalProposal?: Renewal;
    automaticRenewalOn: boolean;
    performRenewal: boolean;
    displayWillBeRenewedConfirmation: boolean;
    classifiersLoaded: boolean;
    policiesProcessed: boolean;
    policyPropertiesLoaded: boolean;
    mainCardId?: string;
    cardExpired?: boolean;
    showRenewalSwitchConfirmation: boolean;
    showAutoRenewalQuestionModal: boolean;
    showAutoRenewalQuestionSuccessModal: boolean;
    registrationNumber?: string;
    reuseCard: boolean;
    showSetUpDirectDebitBanner?: boolean;
    showOldPoliciesTile: boolean;
}

@authorize
export class AnnualMotorDashboardPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {
    private static readonly ENABLE_AUTO_RENEWAL: string = "enable_auto_renewal";

    private readonly pluginTemplates = new PluginTemplates();
    private showSuccessPopup: string | null;
    private successPopupTitle: string;
    private modalContent: React.ReactNode;
    private readonly tourDriver: Driver;
    private referrerJourney: string | null;
    private readonly mobileDetect: MobileDetect;
    private hasMultipleActivePolicies: boolean = false;

    private readonly urlParams = new URLSearchParams(window.location.search);

    @lazyInject(CustomerPortalTypes.CustomerPortalService)
    private readonly customerPortalService: ICustomerPortalService;

    @lazyInject(JourneyCoreTypeDefs.LookupService)
    private readonly lookupService: ILookupService;

    @lazyInject(Types.CacheManager)
    private readonly cacheManager: ICacheManager;

    private pushAdobeDataLayerTimeout: any;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);

        this.state = {
            quotesLoaded: false,
            partyLoaded: false,
            instalmentsInfo: {} as InstalmentsInfo,
            instalmentInfoLoaded: false,
            showCardExpiryBanner: false,
            showFeedbackDialog: false,
            displayOverlay: false,
            renewalProposal: undefined,
            automaticRenewalOn: false,
            performRenewal: false,
            displayWillBeRenewedConfirmation: false,
            classifiersLoaded: false,
            policiesProcessed: false,
            policyPropertiesLoaded: false,
            showAutoRenewalQuestionModal: false,
            showAutoRenewalQuestionSuccessModal: false,
            showRenewalSwitchConfirmation: false,
            registrationNumber: "",
            reuseCard: false,
            showOldPoliciesTile: false
        };

        this.tourDriver = new Driver({
            animate: false,
            // TODO: this is workaround fix for driver.js bug https://github.com/kamranahmedse/driver.js/issues/247
            // fix is taken from https://github.com/kamranahmedse/driver.js/issues/247#issuecomment-774016683
            // related technical debt ticket https://lv-digital.atlassian.net/browse/FAL-18588
            onHighlightStarted: () => {
                if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                    document.body.style.pointerEvents = "none";
                }
                // @ts-ignore onHighlightStarted() is called - tour dialog is open
                this.tourDriver["isOpen" as keyof Driver] = true;
            },
            // TODO: this is workaround fix for driver.js bug https://github.com/kamranahmedse/driver.js/issues/247
            // fix is taken from https://github.com/kamranahmedse/driver.js/issues/247#issuecomment-774016683
            // related technical debt ticket https://lv-digital.atlassian.net/browse/FAL-18588
            onHighlighted: () => {
                if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                    setTimeout(() => {
                        document.body.style.pointerEvents = "auto";
                    }, 500);
                }
            },

            onReset: () => {
                // this is workaround to detect that tour dialog is closed
                // there is no "on close" callback
                // @ts-ignore onReset() is called also before dialog is open, hence we need flag tourDriver.isOpen
                if (this.tourDriver["isOpen"]) {
                    // @ts-ignore tour dialog is closed - remove the flag
                    delete this.tourDriver["isOpen"];
                    this.setState({ displayOverlay: true });
                    this.setState({ displayOverlay: false });
                }
            },
        });

        this.setTour = this.setTour.bind(this);
        this.turnOnNextYearRenewal = this.turnOnNextYearRenewal.bind(this);
        this.setAutomaticRenewal = this.setAutomaticRenewal.bind(this);
        this.setPerformRenewal = this.setPerformRenewal.bind(this);
        this.getBrandName = this.getBrandName.bind(this);

        this.mobileDetect = new MobileDetect(window.navigator.userAgent);
    }

    public componentDidMount() {
        const policyNumber: string = this.props.params.policyNumber;

        this.pluginTemplates.setPageTitle("Dashboard");

        this.customerPortalService.getPolicy(policyNumber).subscribe((policy: Policy) => {
            let vrn: string;
            if (policy?.interaction.process === INTERACTION_PROCESS_MTA_REPLACE_CAR && moment().isBefore(policy.interaction.headerInfo.startDate)) {
                const version: PolicyHistory | undefined = policy.policyHistoryList.find(ph => policy.interaction.agreementVersion - 1 === ph.number);
                vrn = version?.vehicle.registrationNumber!;
            } else {
                vrn = policy.insuredVehicles[0].registrationNumber;
            }

            policy.policyProperties.forEach(property => {
                if (property.key === PolicyPropertyEnum.AUTOMATIC_RENEWAL) {
                    this.setState({ automaticRenewalOn: property.value === "true" });
                } else if (property.key === PolicyPropertyEnum.PERFORM_RENEWAL) {
                    this.setState({ performRenewal: property.value === "true" });
                } else if (property.key === PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD) {
                    this.setState({ mainCardId: property.value });
                } else if (property.key === PolicyPropertyEnum.ANNUAL_MONTHLY_OPTION_CARD_EXPIRED) {
                    this.setState({ cardExpired: property.value === "true" });
                } else if (property.key === PolicyPropertyEnum.REUSE_MAIN_CARD) {
                    this.setState({ reuseCard: property.value === "true" });
                }
            });

            const showSetUpDirectDebitBanner = policy.annualPolicyInfo.isMandateRequiredForRefund && this.referrerJourney !== INTERACTION_PROCESS_MTA_CHANGE_DIRECT_DEBIT;
            this.setState({
                policy,
                policiesProcessed: true,
                registrationNumber: vrn,
                policyPropertiesLoaded: true,
                showSetUpDirectDebitBanner: showSetUpDirectDebitBanner
            });

            if (window.sessionStorage.getItem("showPopup") === "true" && window.sessionStorage.getItem("referrerJourney") === INTERACTION_PROCESS_NB) {
                const interaction = policy.interaction;
                new LVDataLayerHelper().mapInteractionToDataLayer(interaction);
                maybePushPurchaseEvent(window.LvDataLayer.policyReference);
            }
        });

        this.customerPortalService.getProfile().subscribe((party: Party) => {
            this.setState({
                party,
                partyLoaded: true,
                showOldPoliciesTile: party.hasExpiredPolicies,
            });
        });

        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => {
            this.cacheManager.clearCache("getQuotes");
            this.setState({
                quotes,
                quotesLoaded: true,
            });
        });

        this.customerPortalService.getInstalmentsInfo(policyNumber, false).subscribe((instalmentsInfo: InstalmentsInfo) => {
            this.setState({
                instalmentsInfo,
                instalmentInfoLoaded: true,
            });
        });

        this.customerPortalService.getRenewalProposal(policyNumber).subscribe((renewalProposal: Renewal) => {
            this.setState({
                renewalProposal,
            });

            if (this.urlParams.get(AnnualMotorDashboardPagePlain.ENABLE_AUTO_RENEWAL) === "true") {
                if (renewalProposal?.status === POLICY_STATUS_PENDING_RENEWAL) {
                    this.setAutomaticRenewal(true);
                    this.setState({
                        displayWillBeRenewedConfirmation: true,
                    });
                }
            }
        });

        this.lookupService.fetchLookupValues(`all${ProductsEnum.WOLF_MOTOR}`, "en-UK").subscribe(() => {
            this.setState({ classifiersLoaded: true });
        });

        const successModalRef = window.sessionStorage.getItem("referrerJourney");
        const showPopup = window.sessionStorage.getItem("showPopup") === "true";
        if (showPopup) {
            if (
                successModalRef === INTERACTION_PROCESS_RENEWAL ||
                successModalRef === INTERACTION_PROCESS_PENDING_RENEWAL ||
                successModalRef === INTERACTION_PROCESS_PENDING_RENEWAL_UPDATE_DD
            ) {
                this.pushAdobeDataLayerTimeout = pushEventToAdobeDataLayerTimeout(2000, "renewed");
            } else if (successModalRef === INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE || successModalRef === INTERACTION_PROCESS_CLAIM_IMPACT) {
                this.pushAdobeDataLayerTimeout = pushEventToAdobeDataLayerTimeout(2000, "mta_completed");
            }
        }
    }

    public componentWillUnmount() {
        clearTimeout(this.pushAdobeDataLayerTimeout);
    }

    public render() {
        const { policy, party, quotesLoaded, instalmentInfoLoaded, policiesProcessed } = this.state;
        const dataLoaded = policiesProcessed && instalmentInfoLoaded && party && (!policy || quotesLoaded);

        this.hasMultipleActivePolicies = Boolean(party?.multipleActivePolicies);

        // Recreate DataLayer
        if (policy) {
            const interaction = policy.interaction;
            new LVDataLayerHelper().mapInteractionToDataLayer(interaction);
        }

        this.referrerJourney = window.sessionStorage.getItem("referrerJourney");
        this.showSuccessPopup = window.sessionStorage.getItem("showPopup");
        const onClose = this.setPopups();

        return (
            <>
                <Overlay show={!dataLoaded || this.state.displayOverlay || !this.state.classifiersLoaded}/>
                {this.showSuccessPopup && dataLoaded && (
                    this.renderSuccessModal(onClose)
                )}
                {this.state.showRenewalSwitchConfirmation && <RenewNextYearConfirmationModal/>}
                <FalconHeader/>
                <div className="page-contents dashboard-page pt-3">
                    <FalconNavigatorHeader
                        back={{
                            link: "/dashboard",
                            hidden: !this.hasMultipleActivePolicies
                        }}
                        title={this.hasMultipleActivePolicies ? "Car policy" : `Hi ${policy?.policyHolder.firstName ?? ""}`}>
                        {policy && <div className="number-plate-preview mx-0 mb-4">{this.state.registrationNumber}</div>}
                    </FalconNavigatorHeader>
                    {dataLoaded && policy && (
                        <>
                            {this.renderBanners()}
                            <AnnualTiles
                                policies={[policy]}
                                renewalProposal={this.state.renewalProposal}
                                policyNumber={this.props.params.policyNumber}
                                showOldPoliciesTile={this.state.showOldPoliciesTile}
                                hasMultiplePolicies={this.hasMultipleActivePolicies}
                                renewalEnabled={this.state.performRenewal}
                                {...this.props}
                            />
                            <LvToAllianzUKTransferDashboardBanner />
                        </>
                    )}
                    {this.hasMultipleActivePolicies && <BackButton isTop={false} link={"/dashboard/"} />}
                </div>
                <Footer />
            </>
        );
    }

    private renderBanners() {
        const { instalmentsInfo, party, renewalProposal } = this.state;

        const policy: Policy = this.state.policy!;
        if (!policy) {
            return <></>;
        }

        const interaction = policy.interaction;
        const showCardExpiryBanner: boolean = this.state.cardExpired !== undefined;
        const vehicle: any = interaction.vehicles[0];
        const annualPolicyInfo: AnnualPolicyInfo = policy.annualPolicyInfo;
        const brandName = getPrettifiedInteractionBrandName(policy.interaction.brandName);

        const isDirectDebitPaymentType: boolean = annualPolicyInfo.paymentType === "directDebit";
        const hasUnpaidChange = policy.annualPolicyInfo.hasUnpaidChange;
        const hasUnpaidChargebackInvoice = policy.annualPolicyInfo.hasUnpaidChargebackInvoice;
        const hasUnpaidChargebackInfo = !!Object.keys(policy?.annualPolicyInfo.unpaidChargebackInvoiceInfo ?? {}).length;
        const upcomingMtaDate = annualPolicyInfo.maxFutureMtaDate;
        const unpaidRenewalInvoiceAmount = policy.annualPolicyInfo.unpaidRenewalInvoiceAmount;

        const showFutureMTAHeader: boolean = upcomingMtaDate != null && interaction && interaction.process !== INTERACTION_PROCESS_MTC && !hasUnpaidChange;
        const hasPendingRenewal: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_PENDING_RENEWAL);
        const hasRenewalDeclined: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_UNDERWRITING_FAILURE);
        const isRenewalProcess: boolean = interaction && interaction.process === INTERACTION_PROCESS_RENEWAL;
        const hasPolicies: boolean = !!policy;
        const hasActivePolicy: boolean = annualPolicyInfo.isPolicyActive;
        const policyCanceled: boolean = policy.status === POLICY_STATUS_MTC;
        const policyNumber = policy.policyNumber;
        const closedRenewalInvite: boolean = window.sessionStorage.getItem(SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED + policyNumber) === "true";
        const twoDaysGracePeriod: boolean = annualPolicyInfo.inGracePeriod;
        // This is special case for 2 unpaid instalments
        const noUnpaidRenewalInvoiceAmountOrRenewal: boolean = (!annualPolicyInfo.unpaidRenewalInvoiceAmount || (annualPolicyInfo.unpaidRenewalInvoiceAmount && isRenewalProcess));
        const showMissedPayment: boolean = !!annualPolicyInfo && annualPolicyInfo.hasDebt && noUnpaidRenewalInvoiceAmountOrRenewal;
        const monthlyPolicy: boolean = interaction.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;

        const ncdImpactedClaim: boolean = !!policy.interaction.uistate.policyHasNcdImpactedClaims;
        let showOverdueInstalmentsBanner: boolean = false;
        showOverdueInstalmentsBanner = AnnualMotorDashboardPagePlain.showOverdueInstalmentBanner(
            showMissedPayment,
            isDirectDebitPaymentType,
            interaction,
            showOverdueInstalmentsBanner,
            annualPolicyInfo,
        );
        const hasUnpaidInstallmentIdToAmount = !!Object.keys(annualPolicyInfo?.unpaidInstallmentIdToAmount ?? {}).length;

        return (
            <>
                {policy && showFutureMTAHeader && <FutureMTAExplainedHeader policyNumber={policyNumber} policyEndDate={policy.endDate} />}
                {interaction && <MtaLimitWarningBanner interaction={interaction} />}
                {this.state.policyPropertiesLoaded && !hasPendingRenewal && !hasRenewalDeclined && !this.state.performRenewal && !policyCanceled && (
                    <NextYearAutoRenewalBanner turnOnNextYearRenewal={this.turnOnNextYearRenewal} setPerformRenewal={this.setPerformRenewal} />
                )}
                {ncdImpactedClaim && !isDirectDebitPaymentType && !hasActivePolicy && showMissedPayment && <NCDImpactedClaimBanner />}
                {annualPolicyInfo && showOverdueInstalmentsBanner && hasUnpaidInstallmentIdToAmount && (
                    <OverdueInstalmentBanner
                        amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                        unpaidInstallmentIdToAmount={annualPolicyInfo.unpaidInstallmentIdToAmount}
                        policyNumber={interaction.agreementNumber}
                        product={ProductsEnum.WOLF_MOTOR}
                        reuseCard={this.state.reuseCard}
                    />
                )}

                {(!showOverdueInstalmentsBanner || !annualPolicyInfo?.overdueMonthlyInvoiceAmount) && instalmentsInfo && monthlyPolicy && (
                    <NextPaymentBanner
                        showInfoModal={false}
                        instalmentsInfo={instalmentsInfo}
                        smallScreenMarginRequired={true}
                    />
                )}

                {policyCanceled && <CancellationBanner policy={policy} process={interaction.process} />}
                {policy && hasUnpaidChange && <UnpaidChangeBanner unpaidChangeDueDate={annualPolicyInfo.unpaidChangeDueDate} interaction={interaction} />}
                {hasUnpaidChargebackInvoice && hasUnpaidChargebackInfo && !isDirectDebitPaymentType && (
                    <ChargebackBanner
                        policyNumber={policyNumber}
                        unpaidChargebackInvoiceInfo={policy.annualPolicyInfo.unpaidChargebackInvoiceInfo}
                    />
                )}
                {hasUnpaidChargebackInvoice && hasUnpaidChargebackInfo && isDirectDebitPaymentType && (
                    <OutstandingPaymentBanner
                        unpaidChargebackInvoiceInfo={policy.annualPolicyInfo.unpaidChargebackInvoiceInfo}
                        policyNumber={policy.policyNumber}
                        product={policy.interaction.product}
                    />
                )}
                {!!unpaidRenewalInvoiceAmount && isDirectDebitPaymentType && (
                    <MigrationMissedPaymentBanner
                        policyNumber={policy.policyNumber}
                        amount={unpaidRenewalInvoiceAmount}
                        policyStartDate={policy.startDate}
                    />
                )}

                {!policyCanceled && <RenewalMissedPaymentBanner policy={policy} reuseCard={this.state.reuseCard} />}

                {policy && showCardExpiryBanner && (
                    <CardExpiryBanner party={party!} policyNumber={policy.policyNumber} annualMonthlyOptionCardExpired={this.state.cardExpired!} />
                )}
                {hasPendingRenewal && !twoDaysGracePeriod && (this.state.automaticRenewalOn || this.state.performRenewal) && (
                    <PolicyWillBeRenewedBanner
                        renewalProposal={renewalProposal}
                        product={<>{brandName}</>}
                        productContent={
                            <>
                                {vehicle.make} {vehicle.model} {vehicle.registrationNumber}
                            </>
                        }
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.polarisPolicyData.instalmentAllowedStatus === "A"}
                    />
                )}
                {hasRenewalDeclined && hasPolicies && !policyCanceled && (
                    <RenewalDeclinedBanner
                        product="car"
                        endDate={policy.endDate}
                        productWording={
                            <>
                                your {vehicle.make} {vehicle.model} {vehicle.registrationNumber}
                            </>
                        }
                    />
                )}
                {!hasActivePolicy && !ncdImpactedClaim && !showMissedPayment && <NoActivePolicyBanner />}
                {hasPendingRenewal && !twoDaysGracePeriod && !this.state.automaticRenewalOn && !this.state.performRenewal && (
                    <AutoRenewalInviteBanner
                        renewalProposal={this.state.renewalProposal!}
                        setAutomaticRenewal={this.setAutomaticRenewal}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        monthlyInstalmentsAllowed={this.state.renewalProposal?.polarisPolicyData.instalmentAllowedStatus === "A"}
                        renewalEditUrl={RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL}
                        productWording={
                            <>
                                Your {brandName} Insurance policy for{" "}
                                <strong>
                                    {vehicle.make} {vehicle.model} ends on {formatDateTime(policy.endDate)}.
                                </strong>{" "}
                                Until then you're still covered.
                            </>
                        }
                    />
                )}
                {hasPendingRenewal && this.state.displayWillBeRenewedConfirmation && !twoDaysGracePeriod && (
                    <PolicyWillBeRenewedConfirmation
                        currentPolicy={policy}
                        party={party!}
                        mainCardId={this.state.mainCardId!}
                        renewalProposal={this.state.renewalProposal!}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        showAutoRenewalQuestionModal={this.showAutoRenewalQuestionModal}
                    />
                )}
                {hasPendingRenewal &&
                    !closedRenewalInvite &&
                    !this.state.displayWillBeRenewedConfirmation &&
                    !this.state.performRenewal &&
                    !twoDaysGracePeriod && (
                        <AutoRenewalInviteAfterLogin
                            currentPolicy={policy}
                            renewalProposal={this.state.renewalProposal!}
                            setPerformRenewal={this.setPerformRenewal}
                            showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        />
                    )}
                {hasPendingRenewal && !this.state.automaticRenewalOn && twoDaysGracePeriod && (
                    <GracePeriodBanner renewalProposal={this.state.renewalProposal!} vehicle={vehicle} policy={policy} />
                )}
                {hasPendingRenewal && !this.state.automaticRenewalOn && twoDaysGracePeriod && (
                    <GracePeriodModal
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                    />
                )}
                {this.state.showAutoRenewalQuestionModal && !this.state.automaticRenewalOn && (
                    <AutoRenewalQuestionModal currentPolicy={policy} onSave={this.setAutomaticRenewalAndCloseAutoRenewalQuestionModal} />
                )}
                {this.state.showAutoRenewalQuestionSuccessModal && (
                    <AutomaticRenewalSuccessModal
                        automaticRenewal={this.state.automaticRenewalOn}
                        nextYearRenewal={this.state.performRenewal}
                        product={ProductsEnum.WOLF_MOTOR}
                        closeSuccessModal={this.closeAutoRenewalQuestionSuccessModal}
                    />
                )}
                {this.state.showSetUpDirectDebitBanner && <SetUpDirectDebitBanner policyNumber={policyNumber}/>}
            </>
        );
    }

    private static showOverdueInstalmentBanner(
        showMissedPayment: boolean,
        isDirectDebitPaymentType: boolean,
        interaction: any,
        showOverdueInstalmentsBanner: boolean,
        annualPolicyInfo: AnnualPolicyInfo,
    ) {
        if (
            (showMissedPayment && isDirectDebitPaymentType && interaction.process !== INTERACTION_PROCESS_MTC_LV) ||
            (!isDirectDebitPaymentType &&
                showMissedPayment &&
                annualPolicyInfo.unpaidInstallmentIdToAmount &&
                Object.keys(annualPolicyInfo.unpaidInstallmentIdToAmount).length === 2)
        ) {
            showOverdueInstalmentsBanner = showMissedPayment;
        }
        return showOverdueInstalmentsBanner;
    }

    private verifyRenewalProposalStatus(checkStatus: string) {
        return this.state.renewalProposal?.status === checkStatus;
    }

    private readonly handleCloseSuccessPopup = (): void => {
        this.setTour();
    };

    private setTour(): void {
        this.tourDriver?.reset();

        this.tourDriver?.defineSteps([
            {
                element: "#carTile",
                popover: {
                    className: "tour",
                    title: "View and make policy changes",
                    description: `Add driver(s), replace car, modify optional extras, modify your car or driver(s) details, all available here.
                                <div>
                                <ul class="nav-dots">
                                    <li class="nav-dot nav-dot-active"></li>
                                    <li class="nav-dot"></li>
                                    <li class="nav-dot"></li>
                                    <li class="nav-dot"></li>
                                </ul>
                                </div>`,
                    position: "bottom-right",
                    nextBtnText: "Next tip",
                    prevBtnText: "Skip tour",
                },
                onPrevious: () => {
                    // TODO: this is workaround fix for driver.js bug https://github.com/kamranahmedse/driver.js/issues/247
                    // fix is taken from https://github.com/kamranahmedse/driver.js/issues/247#issuecomment-774016683
                    // related technical debt ticket https://lv-digital.atlassian.net/browse/FAL-18588
                    if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                        document.body.style.pointerEvents = "none";
                        setTimeout(() => {
                            document.body.style.pointerEvents = "auto";
                        }, 500);
                    }
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#paymentTile",
                popover: {
                    className: "tour",
                    title: "View and amend payment details",
                    description: `Here you can view a history of your payments, set a new payment day
                    or change your card
                    <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                        </ul>
                    </div>`,
                    position: "bottom-left",
                    nextBtnText: "Next tip",
                    prevBtnText: "Skip tour",
                },
                onPrevious: () => {
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#policyDocumentsTile",
                popover: {
                    className: "tour",
                    title: "Policy documents",
                    description: `This is where you can view and print your policy documents
                   or check the emails we've sent to you
                   <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                                <li class="nav-dot"></li>
                        </ul>
                    </div>`,
                    position: window.innerWidth < 768 ? "bottom-right" : "bottom-left",
                    prevBtnText: "Skip tour",
                    nextBtnText: "Next tip",
                },
                onPrevious: () => {
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#claimsTile",
                popover: {
                    className: "tour",
                    title: "Report a claim online",
                    description: `Here you can make a windscreen or all the other type of claims. We have 24 hours helpline
                    <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                        </ul>
                    </div>`,
                    position: "bottom-left",
                    prevBtnText: "Restart tour",
                    doneBtnText: "End tour",
                },
                onPrevious: () => {
                    this.tourDriver?.start(1);
                },
            },
        ]);
        this.tourDriver?.start();
    }

    private renderSuccessModal(onClose: any): React.ReactNode {
        const monthly: boolean = this.state.policy!.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;
        if (this.referrerJourney === INTERACTION_PROCESS_NB) {
            return (
                <SuccessfulPurchaseModal
                    headerText={monthly ? "Deposit payment complete" : "All done"}
                    modalContent={this.renderSuccessPopup()}
                    onClose={this.handleCloseSuccessPopup}
                />
            );
        } else {
            return (
                <StorageSuccessModal
                    title={this.successPopupTitle}
                    explanationWording={this.modalContent}
                    anythingElseTitle={""}
                    explanationAnythingElseWording={""}
                    onClose={onClose}
                />
            );
        }
    }

    private renderSuccessPopup(): React.ReactNode {
        const monthly: boolean = this.state.policy?.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;
        const policy: Policy = this.state.policy!;
        const amountToPayIs0: boolean = policy?.interaction?.factors?.amountToPay === 0;
        if (!policy) {
            return;
        }
        const annualStartDate = policy.interaction?.headerInfo?.startDate;

        const brandName = getPrettifiedInteractionBrandName(policy.interaction.brandName);
        if (monthly) {
            return (
                <div className="text-center">
                    <p className="mb-1 font-weight-bold">Thanks {this.state.party?.firstName},</p>
                    <p className="mt-3 mb-0">
                        <span className="font-weight-bold">You’re covered.</span>
                    </p>
                    <p className="mt-0 mb-1">
                        <span className="font-weight-bold">
                            Your deposit payment has been taken successfully and your insurance cover is now scheduled to start on{" "}
                            {formatDate(annualStartDate, "DD MMM YYYY")}
                        </span>
                    </p>
                    <p className="mt-3 mb-0">
                        <span className="font-weight-bold">
                            Your direct debit instruction will be confirmed to you by email within 3 working days or no later than 10 working days before the
                            first collection.
                        </span>
                    </p>
                    <p className="mt-3 mb-3">
                        When you’re ready head over to your account where you can check out your documents and manage your policy online.
                    </p>
                    <p className="mb-4">
                        If you do need to contact us then head over to our{" "}
                        <Link className="hyperlink" to={`/dashboard/help/${this.props.params.policyNumber}`}>
                            help
                        </Link>{" "}
                        section for your options.
                    </p>
                    <p className="mb-0 font-weight-bold">Enjoy your new car and thank you for insuring with {brandName} car insurance.</p>
                </div>
            );
        }
        return amountToPayIs0 ? (
            <div className="text-center">
                <p className="mb-1 font-weight-bold">Thanks {this.state.party?.firstName},</p>
                <p className="mt-3 mb-0">
                    <span className="font-weight-bold">You’re covered.</span>
                </p>
                <p className="mt-0 mb-1">
                    <span className="font-weight-bold">Your insurance cover is now scheduled to start on {formatDate(annualStartDate, "DD MMM YYYY")}</span>
                </p>
                <p className="mt-3 mb-3">When you’re ready head over to your account where you can check out your documents and manage your policy online.</p>
                <p className="mb-4">
                    If you do need to contact us then head over to our{" "}
                    <Link className="hyperlink" to={`/dashboard/help/${this.props.params.policyNumber}`}>
                        help
                    </Link>{" "}
                    section for your options.
                </p>
                <p className="mb-0 font-weight-bold">Enjoy your new car and thank you for insuring with {brandName} car insurance.</p>
            </div>
        ) : (
            <div className="text-center">
                <p className="mb-0">Thanks for choosing {this.getBrandName()} car insurance!</p>
                <Link className="hyperlink" to={`/dashboard/annualMotorDocuments/${this.props.params.policyNumber}`}>
                    Access your documents
                </Link>
                <p className="mt-3">
                    <span className="font-weight-bold">Welcome to your {this.getBrandName()} car insurance account</span>, transparent, everything
                    online, customize your cover 24/7
                </p>
            </div>
        );
    }

    private readonly setSuccessfulPaymentPopup = (): void => {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return;
        }

        this.modalContent = (
            <div>
                <p className="font-weight-bold mb-4">Thanks {policy.policyHolder.firstName}</p>
                <p className="mb-4">
                    When you’re ready, check your documents in <a className={"link"} href={`/dashboard/annualMotorAccount/${this.props.params.policyNumber}`}>
                        your online account</a>. This is also where you’ll manage your policy and make any changes.
                </p>
                <p className="mb-4">
                    Remember, we’re just a phone call away if you need to claim, for everything else it’s over to you! If you get stuck, email us and we’ll
                    reply within 24 hours.
                </p>
                <p className="mt-3 font-weight-bold">Welcome to the ${this.getBrandName()} family!</p>
                <div className={"d-flex"}>
                    <img src={`/Allianz/img/allianz-olympic-logo.svg`} alt={`Allianz olympics logo icon`} />
                </div>
            </div>
        );
    };

    private setNewPaymentPopup(): void {
        this.successPopupTitle = "Payment was successful";
        this.modalContent = (
            <p>
                We’ve saved your changes and <b>{window.sessionStorage.getItem("paymentAmount")}</b> has been debited from your card.
                <br />
                Please allow a couple of minutes for the payment to be updated in your account.
            </p>
        );
    }

    private setNewStartDatePopUp(): void {
        const date = window.sessionStorage.getItem("changedStartDate") ? window.sessionStorage.getItem("changedStartDate") : null;
        this.successPopupTitle = "Policy's start date has been changed";
        this.modalContent = (
            <p>
                Your policy will now start on <b>{formatDateDMY(date!)}</b>.
            </p>
        );
    }

    private setEditRenewalSaveSuccessPopup(): void {
        if (this.state.partyLoaded && this.state.renewalProposal && this.state.policyPropertiesLoaded) {
            const premiumType = this.state.renewalProposal.factors.premiumType;

            if (premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY) {
                this.successPopupTitle = "All done!";
                this.modalContent = (
                    <p>
                        <div className="renewal-save-change-success-modal mt-2">
                            <div>All the changes to your renewal policy are saved.</div>
                        </div>
                    </p>
                );
            } else {
                const premiumToDisplay: number = this.state.renewalProposal.factors.amountToPay;
                const paymentCard: PaymentCard | null = this.state.mainCardId
                    ? findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId)
                    : null;
                const startDate = moment(this.state.renewalProposal.headerInfo.startDate).format("DD MMMM YYYY");

                this.successPopupTitle = "All done! All the changes made to your renewal policy are saved.";
                this.modalContent = (
                    <p>
                        <div className="renewal-save-change-success-modal mt-2">
                            <InfoBanner wording={
                                <p className="mx-4 mb-0 grid-col-2">
                                    <strong>Heads up</strong> - if you need any changes to start before your renewal date, go to{" "}
                                    <a
                                        className="font-weight-bold text-decoration-underline"
                                        href={`/dashboard/annualMotor/yourCars/${this.props.params.policyNumber}`}>
                                        Your car, make changes.
                                    </a>
                                </p>
                            }/>
                            <div className="price-section">
                                Your new car insurance renewal price is {getAmountWithDecimalDigits(premiumToDisplay)}. Please check your renewal tile for further
                                details.
                            </div>
                            {paymentCard && (
                                <>
                                    <div>
                                        This will be taken from your card ending in {paymentCard?.cardNumberObfuscated.split("******")[1]} on {startDate}.
                                    </div>
                                    <div>Please check your payment card is still valid.</div>
                                </>
                            )}
                        </div>
                    </p>
                );
            }
        }
    }

    private setSaveClaimImpactPaymentSuccessPopup(): void {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return;
        }

        if (this.state.partyLoaded) {
            const interaction = policy.interaction;

            const { factors, uistate, paymentDetails, policyHolder, agreeToReuseCardDetails } = interaction;

            const mtaSuccessMessageText = window.sessionStorage.getItem("mtaSuccessMessageText");

            const wording = ClaimImpactMtaSuccessModalWordingGenerator.generateModalWording(
                factors,
                paymentDetails.instalmentPlan!.monthlyPayment,
                uistate.payFullPrice,
                mtaSuccessMessageText,
                policyHolder.cardDetails?.at(-1)?.number,
                agreeToReuseCardDetails,
            );

            window.sessionStorage.removeItem("mtaHeadsUpMessageText");
            window.sessionStorage.removeItem("mtaSuccessMessageText");
            this.successPopupTitle = wording.modalTitle ? wording.modalTitle.toString() : "";
            this.modalContent = <>{wording.modalBody}</>;
        }
    }

    private setSaveRenewalSuccessPopup(): void {
        if (this.state.partyLoaded && this.state.policyPropertiesLoaded) {
            const policy: Policy = this.state.policy!;
            if (!policy) {
                return;
            }

            let premiumToDisplay: number;
            const premiumType = policy.interaction.factors.premiumType;
            const premiumChangedToMonthly: boolean =
                policy.interaction.renewalDetails?.lyPremiumType === PREMIUM_TYPE_ANNUAL && policy.interaction.factors.premiumType === PREMIUM_TYPE_MONTHLY;
            if (premiumType === PREMIUM_TYPE_ANNUAL) {
                premiumToDisplay = policy.interaction.factors.amountToPay;
            } else {
                premiumToDisplay = policy.interaction.paymentDetails.instalmentPlan.monthlyPayment;
            }
            const paymentCard: PaymentCard | null = findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId!);
            const vehicle: any = policy.interaction.vehicles[0];

            this.successPopupTitle = premiumType === PREMIUM_TYPE_MONTHLY && !premiumChangedToMonthly ? `All done!` : "Payment was successful";
            this.modalContent = (
                <p>
                    <div className="renewal-save-change-success-modal mt-2">
                        {premiumType === PREMIUM_TYPE_ANNUAL && (
                            <>
                                <div className="price-section">
                                    <span className="price-bold">{getAmountWithDecimalDigits(premiumToDisplay)}</span> was taken from your card ending in{" "}
                                    <span className="card-number-bold">{paymentCard?.cardNumberObfuscated.split("******")[1]}</span> for renewing your{" "}
                                    {vehicle.make}, {vehicle.model} ({vehicle.registrationNumber}) car policy.
                                    <p>Please allow a couple of minutes for the payment to be updated in your account.</p>
                                </div>
                                <div className="card-section">Thanks for choosing {this.getBrandName()} for another year!</div>
                            </>
                        )}
                        {premiumType === PREMIUM_TYPE_MONTHLY &&
                            <div className="price-section">All the changes to your renewal policy are saved.</div>
                        }
                    </div>
                </p>
            );
        }
    }

    private setAutomaticRenewal(value: boolean): void {
        this.setState({
            displayOverlay: true,
        });

        this.customerPortalService.storePolicyAutomaticRenewalFlag(this.props.params.policyNumber, value).subscribe(() => {
            this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${this.props.params.policyNumber},performRenewal`);

            this.setState({
                automaticRenewalOn: value,
                displayOverlay: false,
            });
        });
    }

    private setPerformRenewal(value: boolean): void {
        this.setState({
            displayOverlay: true,
        });

        this.customerPortalService.storePolicyPerformRenewalFlag(this.props.params.policyNumber, value).subscribe(() => {
            this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${this.props.params.policyNumber},performRenewal`);

            this.setState({
                performRenewal: value,
                displayOverlay: false,
            });
        });
    }

    private readonly showHideWillBeRenewedConfirmation = (display: boolean): void => {
        this.setState({
            displayWillBeRenewedConfirmation: display,
        });
    };

    private readonly showAutoRenewalQuestionModal = (): void => {
        this.setState({
            showAutoRenewalQuestionModal: true,
        });
    };

    private readonly setAutomaticRenewalAndCloseAutoRenewalQuestionModal = (automaticRenewal: boolean): void => {
        // true when user accepted next year renewal in modal
        this.setPerformRenewal(true);
        this.setAutomaticRenewal(automaticRenewal);
        this.setState({
            showAutoRenewalQuestionModal: false,
            showAutoRenewalQuestionSuccessModal: true,
            automaticRenewalOn: automaticRenewal,
            performRenewal: true,
        });
    };

    private readonly closeAutoRenewalQuestionSuccessModal = (): void => {
        this.setState({
            showAutoRenewalQuestionSuccessModal: false,
        });
    };

    private turnOnNextYearRenewal(): void {
        this.setPerformRenewal(true);
        this.setState({
            showRenewalSwitchConfirmation: true,
        });
    }

    private setPopups(): any {
        let onClose;
        if (this.referrerJourney === INTERACTION_PROCESS_NB) {
            onClose = this.handleCloseSuccessPopup;
            this.setSuccessfulPaymentPopup();
        } else if (this.referrerJourney === NEW_PAYMENT) {
            window.sessionStorage.removeItem("paymentSettings");
            this.setNewPaymentPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_PENDING_RENEWAL) {
            this.setEditRenewalSaveSuccessPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_RENEWAL) {
            if (!this.state.automaticRenewalOn) {
                onClose = this.showAutoRenewalQuestionModal;
            }
            this.setSaveRenewalSuccessPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE) {
            this.setNewStartDatePopUp();
        } else if (this.referrerJourney === INTERACTION_PROCESS_CLAIM_IMPACT) {
            this.setSaveClaimImpactPaymentSuccessPopup();
        } else {
            window.sessionStorage.removeItem("showPopup");
            window.sessionStorage.removeItem("referrerJourney");
        }
        return onClose;
    }

    private getBrandName(): string {
        return this.props.params.policyNumber ?
            getBrandFromPolicyNumber(this.props.params.policyNumber)! :
            resourcesHelper.THEME_NAME;
    }
}

export const AnnualMotorDashboardPage = withRouter<{}, IParams>(AnnualMotorDashboardPagePlain);
